/**
 * Permission Mapper
 * Maps between API DTOs and Domain Entities
 */

import { PermissionResponseDTO } from "../models/PermissionDTOs";
import { PermissionsMap } from "../../domain/entities/PermissionEntity";

export class PermissionMapper {
  /**
   * Convert PermissionResponseDTO to PermissionsMap entity
   */
  static toPermissionEntity(dto: PermissionResponseDTO): PermissionsMap {
    return dto.data.permissions || {};
  }
}
